module.exports = __webpack_public_path__ + "static/media/rga_graz.feb3aed8.jpeg";